import { Component, OnInit, inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthenticationService, OktaAuthenticationProvider } from '@lc/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'lc-app-okta-callback',
  templateUrl: './okta-callback.component.html',
  styleUrls: ['./okta-callback.component.scss'],
  imports: [MatButton, MatIcon],
})
export class OktaCallbackComponent implements OnInit {
  private auth = inject(AuthenticationService);
  private okta = inject(OktaAuthenticationProvider);

  public errorMsg: string;
  public hasError = false;
  public isRetryButton = true;
  public gatewayReturnLink: string;
  public contactMessage: string;

  ngOnInit() {
    // Handles the response from Okta and parses tokens
    this.okta.handleAuthentication(true).then(() => {
      this.auth.redirectPostLogin();
    }).catch((error) => {
      this.hasError = true;
      this.errorMsg = 'We couldn’t sign you in.';
      this.contactMessage = 'Please try again or contact your application support team.';
      if (error instanceof HttpErrorResponse && error.error?.code === 'COMPASS_AUTH_DISABLED') {
        this.errorMsg = 'Compass access is not available for this account yet.';
      } else if (error instanceof Error && error.message.includes('not assigned')) {
        this.errorMsg = 'User is not assigned to this application.';
        this.isRetryButton = false;
      }
    });
  }

  async retry() {
    await this.okta.logout();
    await this.okta.login();
  }
}
